import request from '../Functions/ajax/request'

export default function ActualitesLoader ({ params })
{
	return { page: getNews({ params }) };
}

async function getNews ({ params })
{
	try
	{
		var { data } = await request('/news/get-last-news')
		.config({ })
		.post();
	}
	catch (update)
	{
		console.error(update);
	}

	return { articles: data || [] };
}